import React from 'react'
import PropTypes from 'prop-types'
import { bem } from '@argos/utils'

import Avatar from '../../Common/Avatar/Avatar'
import { MessagesCount } from '../components'

const cn = bem({ prefix: 'lc-', block: 'launcher' })

export const MinimizedLauncherIcon = ({ agentName, agentCount, unreadMessages, height, width }) => {
  if (unreadMessages > 0) {
    return <MessagesCount count={unreadMessages} className={cn} />
  }
  const avatarType = agentCount > 0 ? 'agent' : 'system'
  return <Avatar agentName={agentName} type={avatarType} height={height} width={width} className={cn('avatar')} />
}

MinimizedLauncherIcon.propTypes = {
  agentName: PropTypes.string,
  agentCount: PropTypes.number.isRequired,
  unreadMessages: PropTypes.number,
  height: PropTypes.number,
  width: PropTypes.number,
}

MinimizedLauncherIcon.defaultProps = {
  unreadMessages: 0,
  height: 20,
  width: 20,
}

export default MinimizedLauncherIcon
